import React from "react";
import CrmLinks from "../../components/Crm/CrmLinks";
import AddLeadForm from "../../components/Crm/CrmAddLead";

const AddLead = () => {
  return (
    <>
      <CrmLinks />
      <AddLeadForm />
    </>
  );
};

export default AddLead;
